import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import headerLogo from "../../assets/logo/Logo.png";
import { RootState } from "../../store";
import { useSelector, useDispatch } from "react-redux";
import { previousStep } from "../../redux/reducers/stepSlice";
import {
  getCarrier,
  getCarrierByBusinessName,
} from "../../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const theme = useTheme();
  const navigate= useNavigate()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [loadingMessage, setLoadingMessage] = useState("");
  const [logo, setLogo] = useState("");

  const step = useSelector((state: RootState) => state.step.step);
  const dispatch = useDispatch();
  const businessName = localStorage.getItem("businessName");
  const handleBackClick = () => {
    navigate(-1)
  };
  useEffect(() => {
    if (businessName) {
      dispatch<any>(getCarrierByBusinessName(businessName))
        .then(unwrapResult)
        .then((res: any) => {
          setLogo(res.logo_url || "");
        })
        .catch((err: any) => {
          setLoadingMessage("Failed to fetch carrier data.");
        });
    } else {
      setLoadingMessage("Email not found.");
    }
  }, [businessName, dispatch]);
  return (
    <Box
      sx={{
        width: "100%",
        height: isMobile ? "60px" : isTablet ? "70px" : "80px",
        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
        borderRadius: isMobile ? "20px 20px 0 0" : "0",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          padding: isMobile ? "0 10px" : isTablet ? "0 15px" : "0 20px",
          alignItems: "center",
          display: "flex",
        }}
      >
        <ArrowBackIosIcon
          sx={{
            color: "white",
            cursor: "pointer",
            fontSize: isMobile ? "18px" : isTablet ? "22px" : "24px",
            marginRight: isMobile ? "10px" : "15px",
          }}
          onClick={handleBackClick}
        />
        {logo !== "" ? (
          <img
            src={logo}
            alt="Logo"
            style={{
              height: isMobile ? "35px" : isTablet ? "45px" : "50px",
              borderRadius: "50%",
            }}
          />
        ) : null}
        <Typography
          sx={{
            color: "white",
            fontSize: isMobile ? "14px" : isTablet ? "18px" : "20px",
            paddingLeft: "15px",
          }}
        >
          {businessName}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
